import logo from "../resources/logo.png"
import { useState } from "react"
import BurgerIcon from "../icon/BurgerIcon"
import XMarkIcon from "../icon/XMarkIcon"
import Link from "../component/Link"
import {
    logoutProfessional,
    selectProfessionalAuthenticationState
} from "../redux/ProfessionalAuthentication"
import { useAppDispatch, useAppSelector } from "../redux/store/hooks"
import { useNavigate } from "react-router-dom"
import {
    NAVIGATION_VIEW,
    NavigationPaths
} from "../navigation/NavigationController"

function MobileTopMenu() {
    const dispatch = useAppDispatch()
    const authenticated = useAppSelector(selectProfessionalAuthenticationState)
    const navigate = useNavigate()
    const [opened, setOpened] = useState<boolean>(false)

    function toggle() {
        setOpened(!opened)
    }

    function logout() {
        dispatch(logoutProfessional())
        navigate("/login")
    }

    return (
        <div className={"shadow flex flex-col px-4"}>
            <div className={"h-[40px] flex items-center w-full"}>
                <div className={"cursor-pointer text-black font-bold"}>
                    <img src={logo} height={40} width={40} />
                </div>
                <div onClick={toggle} className={"ml-auto mr-2 p-1 rounded"}>
                    {opened ? <XMarkIcon /> : <BurgerIcon />}
                </div>
            </div>
            {opened && (
                <div className={"py-6"}>
                    {authenticated ? (
                        <>
                            <Link onClick={toggle} to={"/patients"}>
                                Patient:innen-Übersicht
                            </Link>
                            <Link
                                onClick={toggle}
                                to={
                                    NavigationPaths[
                                        NAVIGATION_VIEW.PROFESSIONAL_DASHBOARD_PHQ8
                                    ].path
                                }>
                                PHQ-8
                            </Link>
                            <Link onClick={logout}>Logout</Link>
                        </>
                    ) : (
                        <>
                            <Link
                                onClick={toggle}
                                to={
                                    NavigationPaths[NAVIGATION_VIEW.SIGN_IN]
                                        .path
                                }>
                                Login
                            </Link>
                            <Link
                                onClick={toggle}
                                to={
                                    NavigationPaths[NAVIGATION_VIEW.SIGN_UP]
                                        .path
                                }>
                                Registrierung
                            </Link>
                        </>
                    )}
                </div>
            )}
        </div>
    )
}

export default MobileTopMenu
